import { render, staticRenderFns } from "./UserCreate.vue?vue&type=template&id=010410b7&"
import script from "./UserCreate.js?vue&type=script&lang=js&"
export * from "./UserCreate.js?vue&type=script&lang=js&"
import style0 from "./UserCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports